import { css, styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { colors } from '#/theme/theme';

export const DropdownListMenuItem = styled(ButtonOrLink)<{
  $disabled?: boolean;
  $logoutLink?: boolean;
}>`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 10px 12px;
  cursor: pointer;
  color: ${colors.lightContentGrey};
  text-decoration: none;
  font-size: inherit;
  font-weight: normal;
  white-space: unset;

  &:hover {
    background-color: ${colors.inputGrey};
    text-decoration: none;
    color: ${colors.mediumContentGrey};
  }

  .truncate {
    overflow: hidden;
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* stylelint-disable-next-line property-no-deprecated */
    -webkit-box-orient: vertical;
    line-clamp: 2;
  }

  &:disabled {
    opacity: 0.25;
  }

  ${(props) =>
    props.$logoutLink &&
    css`
      color: ${colors.decorativePoppy};

      &:hover {
        color: ${colors.decorativePoppy};
        background-color: ${colors.lightRed};
      }
    `}
`;
